angular.module('mercury.modules.error.permission')
.config(["$stateProvider", function($stateProvider) {
  $stateProvider.state('FullWidth.ErrorPermission', {
    templateUrl: 'modules/error/permission/permission.tpl.html',
    resolve: {
      refreshDetails: ["userinfo", function(userinfo) {
        return userinfo.initialize();
      }]
    }
  });
}]);
